export default "__VITE_ASSET__veTSl2Tf__"